import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/filterIconDisabled.svg'
import _imports_1 from '@/assets/filterIcon.svg'
import _imports_2 from '@/assets/cancel.svg'
import _imports_3 from '@/assets/addImage.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-8085a8d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pt-3 pl-5 pr-5 overflow-y-hidden" }
const _hoisted_2 = {
  class: "row w-full justify-between flex",
  style: {"align-items":"center"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "Frameworks", -1))
const _hoisted_4 = { class: "flex items-center gap-3" }
const _hoisted_5 = { class: "flex flex-row-reverse items-center" }
const _hoisted_6 = {
  key: 0,
  src: _imports_0,
  class: "filterIcon"
}
const _hoisted_7 = {
  key: 1,
  src: _imports_1,
  class: "filterIcon"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-3 text-xs" }, " The Global Risks Report 2022, 17th Edition, is published by the World Economic Forum. The information in this report, or on which this report is based, has been obtained from sources that the authors believe to be reliable and accurate. However, it has not been independently verified and no representation or warranty, express or implied, is made as to the accuracy or completeness of any information obtained from third parties. ", -1))
const _hoisted_9 = { class: "mt-3" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "flex items-center justify-between py-4 px-2 rounded" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "pl-2 w-60" }, "Framework", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "h-5 w-5 cursor-pointer"
}, null, -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "popup-priority" }
const _hoisted_16 = { class: "statuscontainer popupbodycontainer" }
const _hoisted_17 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_18 = { class: "w-full" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel" }, "Name", -1))
const _hoisted_20 = ["disabled"]
const _hoisted_21 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_22 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_23 = {
  key: 1,
  class: "invalid-feedback text-xs"
}
const _hoisted_24 = {
  key: 2,
  class: "error-text text-xs"
}
const _hoisted_25 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_26 = { class: "w-full" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel" }, "Description", -1))
const _hoisted_28 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_29 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_30 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_31 = { class: "row w-full upperspacing" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel" }, "Logo", -1))
const _hoisted_33 = { class: "flex justify-center" }
const _hoisted_34 = { class: "flex justify-center" }
const _hoisted_35 = ["htmlFor"]
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "",
  class: "w-20 h-20 cursor-pointer"
}, null, -1))
const _hoisted_37 = [
  _hoisted_36
]
const _hoisted_38 = ["htmlFor"]
const _hoisted_39 = ["id"]
const _hoisted_40 = { class: "flex justify-center items-center mt-2" }
const _hoisted_41 = { key: 0 }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-xs" }, "Selected File : ", -1))
const _hoisted_43 = { class: "text-sm font-bold" }
const _hoisted_44 = {
  key: 1,
  class: "text-xs"
}
const _hoisted_45 = {
  key: 1,
  class: "border w-full rounded py-2 border-lightgrey"
}
const _hoisted_46 = { class: "flex justify-center p-2 items-center" }
const _hoisted_47 = ["htmlFor"]
const _hoisted_48 = ["src"]
const _hoisted_49 = ["htmlFor"]
const _hoisted_50 = ["id"]
const _hoisted_51 = { class: "flex justify-center items-center mt-2" }
const _hoisted_52 = { key: 0 }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-xs" }, "Selected File : ", -1))
const _hoisted_54 = { class: "text-sm font-bold" }
const _hoisted_55 = {
  key: 2,
  class: "text-red-500"
}
const _hoisted_56 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_57 = { class: "buttonposition flex justify-center items-center mb-4 mx-0" }
const _hoisted_58 = ["disabled"]
const _hoisted_59 = ["disabled"]
const _hoisted_60 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_newTable = _resolveComponent("newTable")!
  const _component_tool_tip = _resolveComponent("tool-tip")!
  const _component_popup = _resolveComponent("popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          class: "btnprimary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showAddPopup()))
        }, " Add "),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            class: _normalizeClass(["flex items-center", _ctx.frameworksDataArray.length == 0?'btndisabled pointer-events-none':'filterButton h-8']),
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.filterOpen && _ctx.filterOpen(...args)))
          }, [
            (_ctx.frameworksDataArray.length == 0)
              ? (_openBlock(), _createElementBlock("img", _hoisted_6))
              : (_openBlock(), _createElementBlock("img", _hoisted_7)),
            _createTextVNode(" Filters ")
          ], 2)
        ])
      ])
    ]),
    _hoisted_8,
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_newTable, {
        tableRowData: _ctx.frameworksDataArray,
        headersData: _ctx.headers,
        tableProps: _ctx.tableProps,
        openPopup: false,
        navigate: true,
        loadData: _ctx.dataLoading
      }, null, 8, ["tableRowData", "headersData", "tableProps", "loadData"]),
      (_ctx.toolTipActive)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createVNode(_component_tool_tip, { tipText: _ctx.toolTipText }, null, 8, ["tipText"])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.showFrameworkPopUp)
      ? (_openBlock(), _createBlock(_component_popup, { key: 0 }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("button", {
                class: "float-right text-3xl",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onCancelbtn('close')))
              }, _hoisted_14)
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("fieldset", null, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _hoisted_19,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.frameworkObj.name) = $event)),
                        placeholder: "Name",
                        class: _normalizeClass(["inputboxstyling", {
                            'is-invalid': (_ctx.v$.frameworkObj.name.$error || _ctx.checkFrameworkName),
                            'disableboxstyling': _ctx.frameworkObj._id
                        }]),
                        disabled: _ctx.frameworkObj._id,
                        onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.v$.frameworkObj.name.$touch()))
                      }, null, 42, _hoisted_20), [
                        [
                          _vModelText,
                          _ctx.frameworkObj.name,
                          void 0,
                          { trim: true }
                        ]
                      ]),
                      (_ctx.v$.frameworkObj.name.$error || _ctx.checkFrameworkName)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                            (_ctx.v$.frameworkObj.name.required.$invalid)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_22, "Required"))
                              : (_ctx.checkFrameworkName)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_23, "Framework Name already exists."))
                                : (_ctx.v$.frameworkObj.name.required && _ctx.v$.frameworkObj.name.restrictNameCharacters.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, "Charcter Limit is exceeded"))
                                  : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _hoisted_27,
                      _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.frameworkObj.description) = $event)),
                        placeholder: "Description",
                        class: _normalizeClass(["inputboxstyling", {
                            'is-invalid': _ctx.v$.frameworkObj.description.$error,
                        }]),
                        onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.v$.frameworkObj.description.$touch()))
                      }, null, 34), [
                        [
                          _vModelText,
                          _ctx.frameworkObj.description,
                          void 0,
                          { trim: true }
                        ]
                      ]),
                      (_ctx.v$.frameworkObj.description.$error)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                            (_ctx.v$.frameworkObj.description.required.$invalid)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_29, "Required"))
                              : (_ctx.v$.frameworkObj.description.required && _ctx.v$.frameworkObj.description.restrictDescriptionCharacters.$invalid)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_30, "Charcter Limit is exceeded"))
                                : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _hoisted_32,
                    ((_ctx.frameworkObj.imageUrl == '' && !_ctx.frameworkObj._id) || (_ctx.frameworkObj.imageUrl == '' && _ctx.frameworkObj._id) )
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: _normalizeClass([{'is-invalid borderRed': _ctx.v$.fileName.$error,}, "border w-full rounded py-2 border-lightgrey"])
                        }, [
                          _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("div", null, [
                              _createElementVNode("div", _hoisted_34, [
                                _createElementVNode("label", {
                                  htmlFor: _ctx.frameworkObj,
                                  class: "mt-2"
                                }, _hoisted_37, 8, _hoisted_35),
                                _createElementVNode("label", { htmlFor: _ctx.frameworkObj }, [
                                  _createElementVNode("input", {
                                    type: "file",
                                    id: _ctx.frameworkObj,
                                    style: {"display":"none"},
                                    ref: "fileInput",
                                    onChange: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.updateFileName('fileInput','add')), ["stop"]))
                                  }, null, 40, _hoisted_39)
                                ], 8, _hoisted_38)
                              ]),
                              _createElementVNode("div", _hoisted_40, [
                                (_ctx.fileName!='')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                      _hoisted_42,
                                      _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.fileName), 1)
                                    ]))
                                  : (_ctx.fileName == '')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_44, _toDisplayString('Click on the icon for uploading a file')))
                                    : _createCommentVNode("", true)
                              ])
                            ])
                          ])
                        ], 2))
                      : (_ctx.frameworkObj._id && _ctx.frameworkObj.imageUrl !='')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                            _createElementVNode("div", _hoisted_46, [
                              _createElementVNode("label", {
                                htmlFor: _ctx.frameworkObj,
                                class: "mt-2"
                              }, [
                                _createElementVNode("img", {
                                  src: _ctx.frameworkObj.imageUrl,
                                  alt: "",
                                  class: "w-20 h-20 cursor-pointer"
                                }, null, 8, _hoisted_48)
                              ], 8, _hoisted_47),
                              _createElementVNode("label", { htmlFor: _ctx.frameworkObj }, [
                                _createElementVNode("input", {
                                  type: "file",
                                  id: _ctx.frameworkObj,
                                  style: {"display":"none"},
                                  ref: "fileInput",
                                  onChange: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.updateFileName('fileInput','edit')), ["stop"]))
                                }, null, 40, _hoisted_50)
                              ], 8, _hoisted_49)
                            ]),
                            _createElementVNode("div", _hoisted_51, [
                              (_ctx.fileName!='')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                    _hoisted_53,
                                    _createElementVNode("span", _hoisted_54, _toDisplayString(_ctx.fileName), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                    (_ctx.v$.fileName.$error)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                          (_ctx.v$.fileName.required.$invalid)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_56, "Required"))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_57, [
                  _createElementVNode("button", {
                    disabled: _ctx.clickOnButton,
                    class: _normalizeClass([JSON.stringify(_ctx.frameworkObj) == JSON.stringify(this.dummyFramework) && _ctx.fileName == '' ? 'btndisabled pointer-events-none' :'btnprimary', "btnprimary mr-1.5"]),
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.onCancelbtn('cancel')))
                  }, "Cancel", 10, _hoisted_58),
                  (!_ctx.frameworkObj._id)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        disabled: _ctx.clickOnButton,
                        class: _normalizeClass([JSON.stringify(_ctx.frameworkObj) == JSON.stringify(this.dummyFramework) && _ctx.fileName == '' ? 'btndisabled pointer-events-none' :'btnprimary', "btnprimary mr-1.5"]),
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.addFramework()))
                      }, "Save", 10, _hoisted_59))
                    : (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        disabled: _ctx.clickOnButton,
                        class: _normalizeClass([JSON.stringify(_ctx.frameworkObj) == JSON.stringify(this.dummyFramework) && _ctx.fileName == '' ? 'btndisabled pointer-events-none' :'btnprimary', "btnprimary mr-1.5"]),
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.editFramework()))
                      }, "Update", 10, _hoisted_60))
                ])
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}